import {NavBar} from "../../../organisms/NavBar/NavBar";
import {Typography, Box, Chip} from "@mui/material";
import {AppBar} from "@mui/material";
import React from "react";
import qs from 'qs';
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";


export const NbaMatchupSubNav = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const cleanQueryString = location.search.startsWith('?') ?
        location.search.slice(1) : location.search;
    const parsedParams = qs.parse(cleanQueryString)
    const {view} = parsedParams
    const activeTrendsIsFilled = view === 'active-trends'
    const trendFinderIsFilled = view === 'trend-finder'
    const getLabel = (str: string) => (
        <Typography variant="caption">
            {str}
        </Typography>
    )

    return (
        <Box
            display="flex"
            justifyContent="center"
            mt={1}
        >
            <Chip
                variant={activeTrendsIsFilled ? 'filled' : 'outlined'}
                label={getLabel('Active Trends')}
                color="primary"
                size="small"
                onClick={() => navigate(`${location.pathname}?view=active-trends`)}
                clickable
                style={{marginRight: '4px'}}
            />
            <Chip
                variant={trendFinderIsFilled ? 'filled' : 'outlined'}
                label={getLabel('Trend Finder')}
                size="small"
                color="primary"
                onClick={() => navigate(`${location.pathname}?view=trend-finder`)}
                clickable
                style={{marginLeft: '4px'}}

            />

        </Box>
    )
}